export const SUPERADMINMANAGESALES = 'SUPERADMINMANAGESALES'
export default SUPERADMINMANAGESALES;